import Input from "components/OldInput";
import moment from "moment";
import { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import Api from "services/Api/Api";

const BringPickup = ({ order, ...props }) => {
    const [desiredPickupDate, setDesiredPickupDate] = useState(
        moment().format("YYYY-MM-DD"),
    );
    const [pickupInstructions, setPickupInstructions] = useState("");
    const [availablePickupDates, setAvailablePickupDates] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const cutoffTime = moment().startOf("day").add(17, "hours");
    const isPastCutoffTime = moment().isAfter(cutoffTime);
    const baseOffset = isPastCutoffTime ? 1 : 0;

    useEffect(() => {
        setAvailablePickupDates(
            [0, 1, 2, 3, 4, 5, 6, 7]
                .map((i) => {
                    let day = moment().add(baseOffset + i, "days");
                    if ([6, 7].includes(day.isoWeekday())) {
                        return null;
                    }
                    return {
                        value: day.format("YYYY-MM-DD"),
                    };
                })
                .filter(Boolean),
        );
    }, []);

    const bookPickup = async () => {
        setIsLoading(true);
        try {
            await Api.bookPickup({
                orderId: order.id,
                pickup: {
                    date: `${moment(desiredPickupDate).format("YYYY-MM-DD")}`,
                    instructions: pickupInstructions,
                    timeInterval: {
                        // Bring pickup does not have a time interval, but the pickupFlow in the portal requires a value.
                        start: "00:00",
                    },
                },
            });
            setIsLoading(false);
            props.history.replace(`/orders/${order.id}`);
        } catch (error) {
            setErrorMessage(
                `Ett fel inträffade när upphämtning skulle bokas. Försök igen.`,
            );
        }
    };
    return (
        <div className="border border-black/10 rounded-md mb-2 min-h-[60px] lg:w-3/4 bg-white p-4">
            <div className="flex flex-col mb-2">
                <div className="font-normal mb-2 text-2xl">
                    Boka upphämtning
                </div>
                <div className="font-bold mb-2">
                    Observera att upphämtning med Bring inte kan avbokas.
                </div>
                <div className="flex flex-row space-x-14">
                    <label>Datum</label>
                    <Input
                        onChange={setDesiredPickupDate}
                        type="dropdown"
                        options={availablePickupDates}
                        value={desiredPickupDate}
                    />
                </div>
                <div className="flex flex-col py-2 space-y-2">
                    <label>Instruktioner</label>
                    <Input
                        onChange={setPickupInstructions}
                        value={pickupInstructions}
                        type="textarea"
                        maxLength={240}
                    />
                </div>
            </div>
            <button
                className="c-button c-button--raised"
                onClick={() => bookPickup()}
                disabled={isLoading || pickupInstructions.length > 240}
            >
                Boka upphämtning
            </button>
            {errorMessage && (
                <div className="py-2 text-red-500">{errorMessage}</div>
            )}
        </div>
    );
};

export default withRouter(BringPickup);
